import React, { ReactNode } from "react";
import { useFormHandlerContext } from "../../../controllers/formController";
import { Collapse, Divider, Paper, styled, Grid2 as Grid } from "@mui/material";
import { singleGridItem } from "../fields/defaultStyles";
import UserAttributeMetadataContent from "./UserAttributeMetadataContent";
import { useInputFullName } from "../fields/subForms/NamePrefixContext";

interface UserAttributeMetadataPaperProps {
  children: ReactNode;
  name: string;
}

const AnimatedPaper = styled(Paper, {
  shouldForwardProp: (prop) => prop !== "elevated",
})<{ elevated: boolean }>(({ theme, elevated }) => ({
  transition: theme.transitions.create(["box-shadow", "padding"], {
    duration: theme.transitions.duration.standard,
  }),
  boxShadow: theme.shadows[elevated ? 4 : 0],
  padding: theme.spacing(elevated ? 2 : 0),
  width: "100%",
}));

const UserAttributeMetadataPaper: React.FC<UserAttributeMetadataPaperProps> = ({
  children,
  name,
}) => {
  const fullName = useInputFullName(name);
  const { isMetadataFieldVisible, hasMetadataField } = useFormHandlerContext();

  return hasMetadataField(fullName) ? (
    <AnimatedPaper elevated={isMetadataFieldVisible(fullName)}>
      <Grid container>
        <Grid {...singleGridItem}>{children}</Grid>
        <Grid {...singleGridItem}>
          <Collapse in={isMetadataFieldVisible(fullName)}>
            <Divider sx={{ my: 2 }} />
            <UserAttributeMetadataContent name={fullName} />
          </Collapse>
        </Grid>
      </Grid>
    </AnimatedPaper>
  ) : (
    <>{children}</>
  );
};

export default UserAttributeMetadataPaper;
